import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker
,GetImgCertUser_CBack,RespBkMthdMapp_CBack} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';


import defaultPic from '../assets/images/9.png';
import Comp_Marksheet_One from '../lms_component/comp_marksheet_one';
import Comp_Marksheet_Two from '../lms_component/comp_marksheet_two';
import Comp_View_Pdf from '../lms_component/comp_view_pdf';
//import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';


let loginUser="";
let userObject="";
let companyName="";
let clsCRB;

let rf="0";
class Pre_Sea_Training extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stListClassFee:[],stSetHrfPdf:""};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsCRB=this;
      }
   
     


      
       
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);

RespBkMthdMapp_CBack(this,"e_click_class",function(event){
let chref=event.target.getAttribute("chrf")
//alert();
clsCRB.setState({stSetHrfPdf:chref},()=>{
    $("#divPdfView").modal('show');
})     
    //alert(JSON.stringify(data));
    //props.runSearch(data);
  },"chrf");

}




      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
   
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card card-secondary">
              {/* <!-- /.card-header --> */}
           <div class="card-header">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Pre Sea Traning Certificate</b></h3>
                {/* <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divSessionYear" href="javascript:void(0)">Add New</a> */}
              </div>
              <form class="form-group" id="frmStudentBulkImport" name="frmStudentBulkImport" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">  
            <div className="card-body">
               
               <Comp_Marksheet_One/>
                     <Comp_Marksheet_Two/>             

               
               

                                <div className="col-md-6 respSSL"></div>
                                <div id="updResponsePro"></div>
                                <div class="row">
                                    <div class="col-12">
                                      
                                        <div class="form-group">
                                        {/* <center>
                                            <div class="input-group input-group-sm" style={{"justify-content":"center"}}>
                                                <button type="button" onClick={()=>this.saveWappCompaign()} class="btn btn-primary">Update Now</button>
                                            </div>
                                        </center> */}
                                        </div>
                                        
                                    </div>
                                </div>                    
            </div>   
            </form>   
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Comp_View_Pdf hrfPdf={this.state.stSetHrfPdf} proItem={this.state.stItemProduct} />
<Alert_Content/>
<Footer/>

    {/* <Wa_Credit_Balance_Comp creditUser={this.state.crediUser} creditBalance={this.state.creditBalance} masterBalance={this.state.masterBalance} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default Pre_Sea_Training;